<script>
import CurrPlaceHostel from "./CurrPlaceHostel.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import DialogContractHostel from "../../Dialogs/DialogContractHostel.vue"
import CardStatementComments from "../../Cards/Pichers/CardStatementComments.vue"
import HostelContractPDF from "../../../../../makepdfs/statement_hostel/stm_hostel_contract_pdf"
import _ from "lodash";

export default {
  name: "CardCurrStatement",
  props: {
    dialog_sub_stm_visible: {
      type: Boolean
    }
  },
  data: () => ({
    step: 1,
    status: '',
    value_circular: '',
    reveal: false,
    color_circular: 'teal',
    visible_form_contract: false,
    status_contract_hostel: ''
  }),
  components: {
    CurrPlaceHostel,
    DialogContractHostel,
    CardStatementComments
  },
  mounted: function () {
    this.setStatusStatement();
  },
  computed: {
    ...mapState({
      show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
      user: state => state.mainHostel.user,
    }),
    ...mapGetters({}),
    setDate() {
      return this.show_statement_hostel.created_at?.match(/\d{4}[./-]\d{2}[./-]\d{2}/)[0]
    },
    setTypeStatement() {
      if (this.show_statement_hostel.statement_type === 2) {
        return 'Переселение'
      } else if (this.show_statement_hostel.statement_type === 3) {
        return 'Выселение'
      }
      return 'Заселение'
    },
    preliminary_place() {
      return this.show_statement_hostel?.result_place?.name_hostel + " " + this.show_statement_hostel?.result_place?.name_room
    },
    check_period() {
      const deadline = new Date(new Date().getFullYear(), 6, 7)
      const current_date = new Date();
      if (current_date > deadline) {
        return true // доступ к системе
      } else return true
    },
    check_status_commission() {
      let control_statuses = _.filter(this.show_statement_hostel.commission_statuses, (commission_status) => {
        return commission_status.status_review === 2 || commission_status.status_review === 3
      })

      return control_statuses.length === 0
    },
    check_forming_contract() {
      return _.find(this.show_statement_hostel.commission_statuses, (commission_status) => {
        return commission_status.role === 3 && commission_status.status_review === 2
      })
    }
  },
  watch: {},
  methods: {
    ...mapMutations({
      setEditStatement: 'interactionStatement/setEditStatement',
      setActiveTab: 'interactionStatement/setActiveTab',
      deleteShowStatement: 'interactionStatement/deleteShowStatement',
      setFluorography: 'mainHostel/setFluorography'
    }),
    ...mapActions({
      GetPlacesForDepartment: 'placesInDormitories/GetPlacesForDepartment',
      RemoveStatement: 'interactionStatement/RemoveStatement',
      GetAllCommentsStatement: 'interactionStatement/GetAllCommentsStatement',
    }),
    closeDialogContractHostel() {
      this.visible_form_contract = false
    },
    goToComments() {
      this.GetAllCommentsStatement(this.show_statement_hostel.id)
      this.step = 2
    },
    updateStep() {
      this.step = 1
    },
    setColorCommission(commission) {
      if (commission.status_review === 2) {
        return 'green'
      } else if (commission.status_review === 3) return 'red'

      return 'orange'
    },
    setStatusStatement() {
      let sum_conf_statuses = 0
      this.show_statement_hostel.commission_statuses.forEach((comm) => {
        if (comm.status_review === 2) {
          sum_conf_statuses++
        } else if (comm.status_review === 3) {
          this.color_circular = 'red'
        }
      })

      sum_conf_statuses = sum_conf_statuses * 30
      this.value_circular = (sum_conf_statuses) > 60 ? 100 : sum_conf_statuses
    },
    result_place(res_place) {
      return res_place?.name_hostel + " " + res_place?.name_room
    },
    async removeStatement() {
      await this.RemoveStatement()

      this.setActiveTab(2)
      this.deleteShowStatement()
    },
    getNameCommission(commission) {
      if (commission.role === 1) return "Начальник УСБ"
      if (commission.role === 2) return "Бухгалтер"
      if (commission.role === 3) return "Директор студгодка"
      // if (commission.status_review === "dean_ex_work_confirm") return "Зам. декана по ВР"
      // if (key === "commandant_confirm") return "Комендант"
    },
    fullPlaceHostel(place_hostel) {
      return place_hostel?.name_hostel + ' ' + place_hostel?.name_room
    },
    async updateCurrStatement() {
      await this.GetPlacesForDepartment(this.user.facility_id)
      await this.setEditStatement()
      await this.openDialog()
      await this.setActiveTab(2)
    },
    setStatus(conf) {
      if (conf === false) {
        this.status = 'Рассматривается'
        return 'orange'
      } else {
        this.status = 'Одобрено'
        return 'green'
      }
    },
    openDialog() {
      this.$emit('updateVisibleDialog', {
        dialog_sub_stm_visible: !this.dialog_sub_stm_visible,
      })
    },
    openDialogContractHostel(status) {
      this.visible_form_contract = true
      this.status_contract_hostel = status
    },
    viewContractHostel() {
      HostelContractPDF.createPDF(
          this.show_statement_hostel.contract_hostel.data_contract.full_name,
          this.show_statement_hostel.contract_hostel.data_contract.name_hostel,
          this.show_statement_hostel.contract_hostel.data_contract.name_section,
          this.show_statement_hostel.contract_hostel.data_contract.name_room,
          this.show_statement_hostel.contract_hostel.data_contract.registration_address,
          this.show_statement_hostel.contract_hostel.data_contract.identity_card,
          this.show_statement_hostel.contract_hostel.data_contract.selected_devices
      );
    }
  },
}
</script>

<template>
  <v-card
      elevation="0"
      rounded="xl"
      min-height="100%"
      min-width="100%"
  >
    <v-card-title>
      <v-row no-gutters justify="center">
        <v-col cols="12" class="text-center">
          <div> Заявление № {{ show_statement_hostel.id }}</div>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-chip
              small
              rounded
              elevation="0"
              :color="setStatus(show_statement_hostel.general_confirmation)"
              outlined
              class="text-subtitle-1"
          >
            {{ status }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-divider/>

    <v-card-text>
      <v-window v-model="step">
        <v-window-item :value="1">
          <h5 class="font-weight-thin text-center mb-1">СТАТУСЫ ЧЛЕНОВ КОМИССИИ</h5>
          <div @click="goToComments" class="d-flex justify-center">
            <v-btn
                rounded
                elevation="0"
                small
                text
            >
              Подробнее
              <v-icon
                  right
                  small
              >
                fa-caret-right
              </v-icon>
            </v-btn>
          </div>
          <v-row
              class="mb-4"
              no-gutters
              justify="center"
          >
            <div
                v-for="(commission, index) in show_statement_hostel.commission_statuses"
                :key="index"
                class="group mt-2 mx-2"
            >
              <v-chip
                  :color="setColorCommission(commission, index)"
                  outlined
              >
                <v-icon left>
                  fa-user-circle
                </v-icon>
                {{ getNameCommission(commission) }}
              </v-chip>
            </div>
          </v-row>
          <div
              v-if="(show_statement_hostel.contract_hostel === 'No access' || show_statement_hostel.contract_hostel === null) && check_forming_contract"
          >
            <h5 class="font-weight-thin text-center mb-3">ДОГОВОР НА ПРОЖИВАНИЕ</h5>
            <div class="d-flex justify-center">
              <v-alert
                  class="rounded-xl"
                  type="info"
                  color="teal"
                  outlined
              >
                Сформируйте договор на проживание!
              </v-alert>
            </div>
            <div class="d-flex justify-center">
              <v-btn
                  @click="openDialogContractHostel('create')"
                  color="teal"
                  dark
                  rounded
              >
                Сформировать
                <v-icon right>
                  fa-file
                </v-icon>
              </v-btn>
            </div>
          </div>
          <template
              v-else-if="Object.keys(show_statement_hostel.contract_hostel).length > 0 && show_statement_hostel.contract_hostel !== 'No access'">
            <h5 class="font-weight-thin text-center mb-3">ДОГОВОР НА ПРОЖИВАНИЕ</h5>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="text-center text-subtitle-1">
                  Договор № {{ show_statement_hostel.contract_hostel.id }}
                </div>
              </v-col>
              <v-col cols="12">
                <div class="text-center">
                  <v-btn
                      @click="viewContractHostel"
                      color="teal"
                      small
                      outlined
                      rounded
                  >
                    Просмотр
                    <v-icon right>
                      fa-file
                    </v-icon>
                  </v-btn>
                  <v-btn
                      v-if="show_statement_hostel.contract_hostel.status === 'Отклонил'"
                      @click="openDialogContractHostel('edit')"
                      elevation="0"
                      class="edit-btn ma-2"
                      small
                      rounded
                      outlined
                      color="warning"
                  >
                    Редактировать
                    <v-icon right size="15px">
                      fa-edit
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </template>
          <h5 class="font-weight-thin text-center mb-3">СОСТОЯНИЕ ЗАЯВЛЕНИЯ</h5>
          <div class="d-flex justify-center align-center">
            <v-progress-circular
                :rotate="-90"
                :size="100"
                :width="15"
                :value="value_circular"
                :color="color_circular"
            >
              {{ value_circular }}%
            </v-progress-circular>
          </div>
          <h4 class="font-weight-thin text-center mt-8 mb-3">МЕСТА</h4>
          <v-card class="mx-auto" max-width="300" elevation="0">
            <v-list
                dense
                disabled
                rounded
                flat
                class="pa-0 mt-2"
            >
              <v-list-item-group v-for="(place, index) in show_statement_hostel.place_hostel" :key="index">
                <v-list-item>
                  <v-list-item-icon disable-icon-rotate class="mr-2 d-flex justify-end">
                    <v-icon size="20px">
                      fa-bed
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="d-flex justify-center text-subtitle-1">
                      {{ fullPlaceHostel(place) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
          <h4 class="font-weight-thin text-center mt-8 mb-3">ОБЩЕЕ</h4>
          <v-row no-gutters>
            <v-col class="d-flex justify-center align-center">
              <v-card
                  elevation="0"
              >
                <v-card-title class="pa-0 font-weight-thin text--secondary">
                  Тип заявления
                </v-card-title>
                <v-card-text class="pa-0 text--primary text-subtitle-1">{{ setTypeStatement }}</v-card-text>
              </v-card>
            </v-col>
            <v-col class="d-flex justify-center align-center">
              <v-card
                  elevation="0"
              >
                <v-card-title class="pa-0 font-weight-thin text--secondary">
                  Дата создания
                </v-card-title>
                <v-card-text class="pa-0 text--primary text-subtitle-1">{{
                    show_statement_hostel.created_at
                  }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>
        <v-window-item :value="2">
          <CardStatementComments
              @updateStep="updateStep"
          />
        </v-window-item>
      </v-window>
    </v-card-text>
    <DialogContractHostel
        :visible_form_contract="visible_form_contract"
        :status_contract_hostel="status_contract_hostel"
        @closeDialogContractHostel="closeDialogContractHostel"
    />
    <v-card-actions v-if="check_status_commission">
      <v-spacer/>
      <div>
        <v-btn
            small
            class="mx-auto"
            @click="updateCurrStatement()"
            color="teal darken-1"
            outlined
            rounded
        >
          Редактировать
        </v-btn>
        <v-btn
            small
            class="mx-auto"
            @click="removeStatement()"
            color="red darken-1"
            outlined
            rounded
        >
          Удалить
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.v-card--reveal {
  top: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.scrollable-card {
  overflow-y: auto;
  max-height: 100%;
}

.sticky-title {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
</style>